class BESSAppProjectEditorPercentageInputField extends BESSAppProjectEditorInputField {

    _configureInput(input) {
        super._configureInput(input);
        input.attr('type', 'number')
            .attr('min', 0)
            .attr('max', 100)
            .attr('step', 1);
    }

    validate() {
        let result = super.validate();
        if (result === null) {
            if (this.isRequired() && !this.hasValue()) {
                return 'This field is required';
            }
        }
        return result;
    }

    _convertInputValue(inputValue) {
        if (inputValue === '') return '0';
        return inputValue;
    }

    hasValue() {
        let value = this.value.value;
        return value != null && value !== '' && value >= 0 && value <= 100;
    }

    _toDataValue(value) {
        if (value !== '') {
            return parseInt(value);
        }
        return null;
    }
}